var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 124,
    viewBox: "0 0 111 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_736_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.3274 52.0626L80.3143 52.3552L80.4375 44.6504C80.4911 41.1472 78.7863 38.0207 76.1419 36.1249C74.5008 34.9485 72.4969 34.2408 70.3263 34.2075L62.6139 34.0789L62.3274 52.0626V52.0626ZM39.1227 56.8339L38.8318 74.8182C38.7178 81.8236 42.1285 88.0698 47.4198 91.8631C56.5656 98.4195 69.436 96.4105 76.1045 87.1084C78.4575 83.8262 79.8684 79.8191 79.9368 75.4754L80.2265 57.4979L39.1227 56.8339V56.8339ZM57.477 33.9991L49.7754 33.882C44.0959 33.7872 39.4206 38.3126 39.3318 43.9889L39.2018 51.6926L57.1887 51.9853L57.477 33.9991V33.9991ZM43.9827 44.06C44.0331 40.9552 46.5729 38.4824 49.7026 38.5354L52.7489 38.5821L52.61 47.2565L43.9331 47.1157L43.9827 44.06V44.06ZM39.6427 32.4342L36.4874 23.5318L39.6606 22.4061L42.5266 30.4982C41.5006 31.0298 40.5396 31.6728 39.6427 32.4342V32.4342ZM34.1728 43.8016L25.4587 43.7181L25.4904 40.3519L34.6462 40.4314C34.3757 41.5274 34.1982 42.6481 34.1728 43.8016ZM35.656 37.5908L27.8412 31.9885L29.802 29.2533L37.4378 34.7273C36.7436 35.6264 36.133 36.5741 35.656 37.5908Z",
    fill: "#3A89FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_736_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62 53.0036C62 51.3548 63.8828 50.4142 65.2011 51.4044L105.257 81.4906C106.664 82.5479 106.118 84.7769 104.381 85.0631L91.2613 87.2244C89.9312 87.4435 89.1944 88.8888 89.7984 90.0939L100.369 111.184C100.872 112.188 100.45 113.409 99.4341 113.889L92.4902 117.166C91.5076 117.63 90.3345 117.224 89.8481 116.252L79.0845 94.7497C78.5042 93.5905 76.9914 93.2811 76.0027 94.1194L65.2934 103.199C63.9939 104.301 62 103.377 62 101.673V53.0036Z",
    fill: "url(#paint0_radial_736_11)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_736_11",
    x: 20,
    y: 9,
    width: 128.057,
    height: 150.358,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 21
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_736_11"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_736_11",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_736_11",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.4228 51.0529) rotate(54.8722) scale(79.694 120.028)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_736_11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74.4417,
    height: 74.4417,
    fill: "white",
    transform: "translate(43.3723 5) rotate(35.636)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClick);
export default __webpack_public_path__ + "static/media/click.fb7169fbf2efad7b7132405ed0039f6b.svg";
export { ForwardRef as ReactComponent };